import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const primary = {
    50: '#f0f2fe',
    100: '#e2e5fc',
    200: '#d4d9fa',
    300: '#c5cdf8',
    400: '#b7bff6',
    500: '#a9b2f5',
    600: '#8c9bf4',
    700: '#7089f4',
    800: '#5a6ec3',
    900: '#435392',
    950: '#2c3861',
};

export const NextpassPartnersPreset = definePreset(Aura, {
    semantic: {
        primary: primary,
    },
});
